export const THREE_YEARS_PREMIUM_VIRTUAL_PRODUCT = '4100040';

export const PREMIUM_VIRTUAL_PRODUCTS_SKU = ['4100010', '4100020', '4100030', THREE_YEARS_PREMIUM_VIRTUAL_PRODUCT];
